export const SWITCH_VIEW_MODE = 'SWITCH_VIEW_MODE';
export const SWITCH_LIST_MODE = 'SWITCH_LIST_MODE';

export enum CalendarView {
    Day = 'Day',
    Week = 'Week',
    Month = 'Month'
}

export type CalendarViewType = typeof CalendarView[keyof typeof CalendarView];

export enum CalendarModes {
    ListDay = 'listDay',
    ListWeek = 'listWeek',
    ListMonth = 'listMonth',
    TimeGridDay = 'timeGridDay',
    TimeGridWeek = 'timeGridWeek',
    DayGridMonth = 'dayGridMonth'
}

export type CalendarModeTypes = typeof CalendarModes[keyof typeof CalendarModes];

export enum CalendarActions {
    SWITCH_VIEW_MODE = 'SWITCH_VIEW_MODE',
    SWITCH_LIST_MODE = 'SWITCH_LIST_MODE'
}

export type CalendarActionTypes = typeof CalendarActions[keyof typeof CalendarActions];

/**
 * Switch the calendar view.
 *
 * @param {'Day'|'Week'|'Month'} viewType
 * @returns {{viewType: CalendarViewType, type: string}}
 */
export const switchViewType = (viewType: CalendarViewType): { viewType: CalendarViewType; type: string; } => {
    return {type: SWITCH_VIEW_MODE, viewType};
};

/**
 * Switch the list mode on/off.
 *
 * @param {boolean} listMode
 * @returns {{listMode: boolean, type: string}}
 */
export const switchListMode = (listMode: boolean): { listMode: boolean; type: string; } => {
    return {type: SWITCH_LIST_MODE, listMode: listMode};
}
